import EmptyState from '@atlaskit/empty-state';
import { GenericErrorImage, TabHeader } from '@atlassian/developer-space';
import { ANALYTICS_ACTION_CLICKED, ANALYTICS_SUBJECT_BUTTON, UI_EVENT_TYPE, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useFeatureFlags } from '@atlassian/mpac-feature-flags';
import { usePartnerPermissions } from '@atlassian/mpac-ui';
import React, { useState } from 'react';
import { useResultsPerPage } from '../../../common/components/useResultsPerPage';
import { ANALYTICS_SUBJECT_ID_ADD_CONTACT } from '../../analytics/Events';
import { TABLE_NAMES } from '../../constants/Preferences';
import AddManageContactModal from './AddManageContactModal';
import { CONTACT, CONTACT_MODAL_ACTIONS, CONTACT_MODAL_BUTTON_TEXT, TEAM, TEAM_MEMBER_MODAL_BUTTON_TEXT } from './AddManageContactModal/AddManageContactModal.types';
import ContactsFilter from './ContactsFilter';
import { usePartnerContacts } from './hooks';
import PartnerContactsTable from './PartnerContactsTable/PartnerContactsTable';
const PartnerContacts = props => {
  const [showContactModal, setContactModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const {
    resultsPerPage
  } = useResultsPerPage(TABLE_NAMES.CONTACTS_TABLE);
  const [search, setSearch] = useState();
  const [role, setRole] = useState();
  const partnerPermissions = usePartnerPermissions();
  const {
    showCopyChangesForPartnerContact
  } = useFeatureFlags();
  const {
    partnerContactList,
    pending,
    error,
    refresh
  } = usePartnerContacts(props.mpacBaseUrl, props.partnerId, search, role,
  // offset in which the paginated results should start from (for ex: 0, 10, 20)
  (pageNumber - 1) * resultsPerPage, resultsPerPage);
  const fireAnalyticsEvent = useAnalyticsEvents();
  const refreshContactsTable = () => {
    if (refresh) {
      refresh();
    }
  };
  const onContactModalSubmit = () => {
    refreshContactsTable();
    toggleContactModal();
  };
  const onSearchChange = value => {
    setPageNumber(1);
    setSearch(value);
  };
  const onRoleChange = value => {
    setPageNumber(1);
    setRole(value);
  };
  const toggleContactModal = () => {
    fireAnalyticsEvent({
      eventType: UI_EVENT_TYPE,
      actionSubjectId: ANALYTICS_SUBJECT_ID_ADD_CONTACT,
      attributes: {
        action: ANALYTICS_ACTION_CLICKED,
        actionSubject: ANALYTICS_SUBJECT_BUTTON
      }
    });
    setContactModal(!showContactModal);
  };
  const canAddManageContact = !!(partnerPermissions !== null && partnerPermissions !== void 0 && partnerPermissions.isSiteAdmin || partnerPermissions !== null && partnerPermissions !== void 0 && partnerPermissions.isPartnerAdmin);
  const showAddToContactButtonText = showCopyChangesForPartnerContact ? TEAM_MEMBER_MODAL_BUTTON_TEXT.ADD : CONTACT_MODAL_BUTTON_TEXT.ADD;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabHeader, {
    headerText: showCopyChangesForPartnerContact ? TEAM : CONTACT,
    ctaText: canAddManageContact ? showAddToContactButtonText : '',
    onCTAClick: toggleContactModal
  }), showContactModal && /*#__PURE__*/React.createElement(AddManageContactModal, {
    action: CONTACT_MODAL_ACTIONS.ADD,
    mpacBaseUrl: props.mpacBaseUrl,
    partnerId: props.partnerId,
    onClose: toggleContactModal,
    onSubmit: onContactModalSubmit
  }), /*#__PURE__*/React.createElement(ContactsFilter, {
    onSearchChange: onSearchChange,
    onRoleChange: onRoleChange
  }), !error && /*#__PURE__*/React.createElement(PartnerContactsTable, {
    mpacBaseUrl: props.mpacBaseUrl,
    partnerId: props.partnerId,
    canManage: canAddManageContact,
    partnerContactList: partnerContactList,
    isContactsLoading: pending,
    pageNumber: pageNumber,
    refreshContactsTable: refreshContactsTable,
    setPageNumber: setPageNumber
  }), error && /*#__PURE__*/React.createElement(EmptyState, {
    header: "We ran into a little trouble",
    description: "It might just be a hiccup. Try again in a bit.",
    imageUrl: GenericErrorImage
  }));
};
export default PartnerContacts;